import { render } from "./contracted_hotel_overview.vue?vue&type=template&id=efb8f4dc"
import script from "./contracted_hotel_overview.vue?vue&type=script&lang=js"
export * from "./contracted_hotel_overview.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__